/**
 * 区域管理
 */
<template>
  <div>
    <div style="margin: 20px">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>调度计划</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <div>
        <el-form :inline="true" :model="formInline" style="margin-top: 20px; heigth: 60px">
          <el-form-item label="计划名称:">
            <el-input size="small" v-model="formInline.plan_name" placeholder="请输入计划名称" clearable
              @keyup.enter.native="search()"></el-input>
        </el-form-item>

        <!-- <el-form-item label="创建人:">
            <el-input
              size="small"
              v-model="formInline.creator"
                                                    placeholder="请输入创建人"
                                                  ></el-input>
                                                </el-form-item> -->
          <el-form-item label="负责人:">
            <el-input size="small" v-model="formInline.head" placeholder="请输入负责人" @keyup.enter.native="search()"
              clearable=""></el-input>
          </el-form-item>
          <el-form-item label="任务状态:">
            <el-select size="small" clearable filterable v-model="formInline.plan_status" placeholder="请选择任务状态">
              <el-option v-for="item in planStatusOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间:">
            <div class="block">
              <el-date-picker size="small" v-model="formInline.create_date" value-format="yyyy-MM-dd" type="date"
                placeholder="选择创建时间">
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="success" icon="el-icon-plus" @click="addDispatch()"
              v-if="check_auth('/web/schedule/add')">添加计划</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--列表-->
      <div style="margin-top: 20px">
        <el-table :data="listData" border element-loading-text="拼命加载中" style="width: 100%">
          <el-table-column align="center" label-aligin="center" prop="id" label="ID" width="80"></el-table-column>
          <el-table-column align="center" label-aligin="center" prop="planName" min-width="200" label="调度计划">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="headUser.name" label="负责人" min-width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.headUser">{{ scope.row.headUser.name }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="startTimeStr" min-width="200" label="任务开始时间">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="endTimeStr" min-width="200" label="任务完成时间">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="createTimeStr" min-width="200" label="创建时间">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="planStatus" width="200" label="计划状态">
            <template slot-scope="scope">
              <el-tag :color="scope.row.status_type" style="color:white">{{
                scope.row.planStatus
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label-aligin="center" label="操作" fixed="right" width="250"
            v-if="check_auth('/web/schedule/update') || check_auth('/web/schedule/delete') || check_auth('/web/schedule_task/list')">
            <template slot-scope="scope">
              <el-button round size="mini" @click="editDispatch(scope.row)" :disabled="scope.row.planStatus !== '未开始'"
                v-if="check_auth('/web/schedule/update')">
                编辑</el-button>
              <el-button round size="mini" type="danger" @click="delDispatch(scope.row)"
                :disabled="scope.row.planStatus !== '未开始'" v-if="check_auth('/web/schedule/delete')">删除</el-button>
              <el-button round type="warning" size="mini" @click="DispatchTask(scope.row)"
                v-if="check_auth('/web/schedule_task/list')">调度任务</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      <!-- 添加界面 -->
      <el-dialog :title="addtitle" :visible.sync="addFormVisible" width="35%" @close="closeDialog"
        :destroy-on-close="true" :close-on-click-modal="false">
        <el-form label-width="17%" :model="addForm" :rules="rules" ref="addForm">
          <el-form-item label="计划名称" prop="planName">
            <el-input size="small" v-model="addForm.planName" clearable auto-complete="off" placeholder="请输入计划名称">
            </el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="head">
            <el-select size="small" clearable style="width: 100%" filterable v-model="addForm.head" placeholder="请选择负责人">
              <el-option v-for="item in planHeadOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始结束时间" prop="time_upend">
            <div class="block">
              <el-date-picker size="small" clearable style="width: 100%" v-model="addForm.time_upend"
                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['08:00:00', '17:00:00']" type="datetimerange"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" :loading="loading" class="addtitle" @click="submitAdd('addForm')">保存
          </el-button>
          <el-button size="mini" @click="closeDialog('addForm')">取消</el-button>
        </div>
      </el-dialog>
      <!-- 编辑界面 -->
      <el-dialog :title="edittitle" :visible.sync="editFormVisible" width="35%" @close="closeDialog"
        :destroy-on-close="true" :close-on-click-modal="false">
        <el-form label-width="17%" :model="editForm" :rules="rules" ref="editForm">
          <el-form-item label="计划名称" prop="planName">
            <el-input size="small" v-model="editForm.planName" clearable auto-complete="off" placeholder="请输入计划名称">
            </el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="head">
            <el-select size="small" clearable filterable style="width: 100%" v-model="editForm.head" placeholder="请选择负责人">
              <el-option v-for="item in editPlanHeadOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始结束时间" prop="time_upend">
            <div class="block">
              <el-date-picker size="small" clearable style="width: 100%" v-model="editForm.time_upend"
                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['08:00:00', '17:00:00']" type="datetimerange"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" :loading="loading" class="edittitle" @click="submitForm('editForm')">
            保存</el-button>
          <el-button size="mini" @click="closeDialog('editForm')">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  get_dispatch_list,
  get_dispatch_add,
  get_planHead_list,
  get_dispatch_del,
  get_dispatch_one,
  get_dispatch_edit,
} from "../../api/dispatch/dispatch";
import Pagination from "../../components/Pagination";
import router from "@/router";
import {
  auth
} from "../../utils/util";
export default {
  data() {
    return {
      editFormVisible: false, //控制编辑页面显示与隐藏
      addFormVisible: false,
      loading: false, //是显示加载
      planStatusOptions: [
        {
          value: 0,
          label: "未开始",
        },
        {
          value: 1,
          label: "进行中",
        },
        {
          value: 2,
          label: "已结束",
        },
        {
          value: 3,
          label: "已过期",
        },
      ],
      planHeadOptions: [],
      editPlanHeadOptions: [],
      addtitle: "添加",
      edittitle: "修改",
      addForm: {
        id: "",
        planName: "",
        head: "",
        time_upend: [],
      },
      editForm: {
        id: "",
        planName: "",
        head: "",
        time_upend: [],
      },
      // rules表单验证
      rules: {
        planName: [
          { required: true, message: "请输入计划名称", trigger: "blur" },
        ],
        head: [{ required: true, message: "请选择负责人", trigger: "change" }],
        time_upend: [
          {
            required: true,
            message: "请选择开始和结束时间",
            trigger: "change",
          },
        ],
      },
      formInline: {
        id: "",
        plan_name: "",
        creator: "",
        head: "",
        plan_status: "",
        create_date: "",
        page: 1,
        limit: 10,
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      listData: [],
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getData();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    DispatchTask(row) {
      router.push({
        path: "/dispatch/dispatch_task",
      });
      window.localStorage.setItem("plan_task", row.id);
    },
    check_auth(val) {
      return auth(val);
    },
    // 事故列表
    getData() {
      window.localStorage.removeItem("plan_task");
      get_dispatch_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.listData = res.data.data;
          for (let i = 0; i < this.listData.length; i++) {
            this.listData[i].status_type = {
              "0": "#909399",
              "1": "#409EFF",
              "2": "#F56C6C",
              "3": "#E6A23C",
            }[this.listData[i].planStatus]
            this.listData[i].planStatus = {
              "0": "未开始",
              "1": "进行中",
              "2": "已结束",
              "3": "已过期",
            }[this.listData[i].planStatus]
          }
          this.pageparm.total = res.data.total;
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getData();
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getData();
    },
    getPlanHead() {
      get_planHead_list().then((res) => {
        if (res["code"] === 0) {
          this.planHeadOptions = res.data;
        }
      });
    },
    //显示添加界面
    addDispatch() {
      this.addFormVisible = true;
      this.addForm = {};
      this.getPlanHead();
    },
    // 添加信息
    submitAdd(addData) {
      this.$refs[addData].validate((valid) => {
        if (valid) {
          get_dispatch_add(this.addForm).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              this.addFormVisible = false;
              this.getData();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 编辑 负责人列表
    getEditPlanHead() {
      get_planHead_list().then((res) => {
        if (res["code"] === 0) {
          this.editPlanHeadOptions = res.data;
        }
      });
    },
    //显示编辑界面
    editDispatch(row) {
      this.edittitle = "修改";
      this.getEditPlanHead();
      get_dispatch_one(row.id).then((res) => {
        if (res["code"] === 0) {
          this.editForm = res.data;
          this.editFormVisible = true;
          this.$set(this.editForm, "time_upend", [
            res.data.startTimeStr,
            res.data.endTimeStr,
          ]);
        }
      });
    },
    // 修改保存
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          get_dispatch_edit(this.editForm).then((res) => {
            this.editFormVisible = false;
            if (res["code"] === 0) {
              this.getData();
              this.$message.success(res["message"]);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 删除
    delDispatch(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          get_dispatch_del(row.id).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              if (this.listData.length === 1) {
                if (this.formInline.page === 1) {
                  this.getData();
                } else {
                  this.formInline.page = this.formInline.page - 1;
                  this.getData();
                }
              } else {
                this.getData();
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.addFormVisible = false;
    },
  },
};
</script>

<style scoped>
.close {
  width: 1.5%;
  height: 2.5%;
  position: absolute;
  top: 8%;
  left: 97%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/dispatch/dispatch_mn.vue